import { Injectable } from '@angular/core';
import { MatTreeNestedDataSource } from '@angular/material/tree';

import { Constants } from '../lib/constants';
//import { TreeType } from '../../../enums/treeTypeEnum';
import { TreeNode, VelaInput, Versions, BoilerPart } from '@usimweb/core/models';
import { Boiler } from './boiler';
import { Helper } from './helper';

export enum TreeType {
  INPUT_TREE = 'inputTree',
  VERSION_TREE = 'versionTree',
  NO_VERSION_TREE = 'noVersionTree',
}

@Injectable({
  providedIn: 'root',
})
export class TreeService {
  // FIX ME
  // remove state here
  private inputTree = new MatTreeNestedDataSource<TreeNode>();

  constructor() {}

  private createTree(tree: VelaInput) {
    let inputChilds: TreeNode[] = [];
    let versionChilds: TreeNode[] = [];

    Object.entries(tree).forEach(([key, value]) => {
      let children: TreeNode[] = [];

      if (Array.isArray(value)) {
        value.forEach((category: any, index) => {
          let name = category.name.value;

          children.push({
            name: name,
            data: category,
            index: index,
            isActive: true,
            type: TreeType.INPUT_TREE,
            part: key as BoilerPart,
          });
          index++;
        });
      }

      if (children.length > 0) {
        // categories with arrays
        inputChilds.push({
          data: value,
          name: key,
          children: children, // set child categories
          type: TreeType.INPUT_TREE,
        });
      } else {
        // categories without arrays
        inputChilds.push({
          data: this.setArrayDefaults(value),
          name: key,
          type: TreeType.INPUT_TREE,
        });
      }
    });

    if (versionChilds.length === 0) {
      console.log('set no version tree');
      versionChilds = [{ name: 'No simulations', data: [], type: TreeType.NO_VERSION_TREE }];
    }

    const customOrder = ['tank', 'filling', 'insulation', 'connections', 'patches', 'heatExchangers', 'simulation'];
    inputChilds.sort((a, b) => {
      return customOrder.indexOf(a.name) - customOrder.indexOf(b.name);
    });

    const treeNode = [
      {
        name: Constants.General.SIM_SETUP,
        children: inputChilds,
        collapse: true,
        type: TreeType.INPUT_TREE,
      },
      {
        name: Constants.General.SIM_HISTORY,
        children: versionChilds,
        collapse: true,
        type: TreeType.VERSION_TREE,
      },
    ] as TreeNode[];

    // if (treeControl) {
    //   treeControl.expand(treeNode[0]);

    //   if (versionChilds.length > 0) {
    //     treeControl.expand(treeNode[1]);
    //   }
    // }

    return treeNode;
  }

  private setArrayDefaults(obj: any) {
    Object.entries(obj).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        obj[key] = { default: value[0], options: value };
      }
    });

    if (Array.isArray(obj)) {
      obj.forEach((element) => {
        Object.entries(element).forEach(([key, value]) => {
          if (Array.isArray(value)) {
            element[key] = { default: value[0], options: value };
          }
        });
      });
    }

    return obj;
  }

  public initTree(tree: VelaInput) {
    this.inputTree.data = this.createTree(Helper.Array.deepCopy(tree));
    return this.inputTree;
  }

  public updateVersion(tree: TreeNode[], versions: Versions[]) {
    let childernSim: TreeNode[] = [];

    versions
      .slice()
      .reverse()
      .forEach((version: any, index: number) => {
        const name = version.name ? version.name : 'Run ' + index;

        childernSim.push({
          name: name,
          data: version,
          type: TreeType.VERSION_TREE,
        });
      });

    if (versions.length === 0) {
      childernSim = [{ name: 'No simulations', data: [], type: TreeType.NO_VERSION_TREE }];
    }

    tree[1].children = childernSim;

    return tree;
  }

  public delete(tree: TreeNode, store: any, fromStore: any) {
    const index = tree.index || 0;
    store.dispatch(new fromStore.RmActorTree({ key: tree.part, index: index }));
    //FIXME not needed for patches
    if (tree.part != BoilerPart.PATCH) {
      Boiler.removeActor(tree.index || 0, tree.part as any);
    }
  }

  public deleteVersion(version: Versions, store: any, fromStore: any) {
    store.dispatch(new fromStore.DeleteVersion(version));
  }

  public highLight(treeNode: TreeNode) {
    if (treeNode.index !== undefined && treeNode.part) {
      Boiler.highLightActor(treeNode.index, treeNode.part);
    }
  }

  // public toggle(tree: TreeNode, toogle: boolean) {
  //   const data = this.inputTree.data[0];
  //   const children = data.children;

  //   if (children) {
  //     children.forEach((child) => {
  //       if (tree.name.includes(child.name)) {
  //         const innerChild = child.children;
  //         if (innerChild && tree.index) {
  //           const item = innerChild[tree.index];
  //           item.isActive = toogle;
  //         }
  //       }
  //     });
  //   }

  //   return data;
  // }
}
